import { createStore, useStore } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { identity } from 'ramda';

interface LiveSearchState {
  query: string | null;
  setQuery: (query: string) => void;
}

export const liveSearchStore = createStore<LiveSearchState>()(
  immer((set) => ({
    query: null,
    setQuery: (query) => {
      set(() => ({ query }));
    },
  }))
);

export const useLiveSearchStore = () => useStore(liveSearchStore, identity<LiveSearchState>);
